import { apiGetClient, apiPostClient, apiPutClient } from "../../../api/apiSvtAdminCore";
import { toast } from 'react-toastify';
import i18n from "i18next";
const t = i18n.t.bind(i18n);


export const getAllSlots = async () => {
    try {
        const response = await apiGetClient.get("slots");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const createNewSlot = async (data) => {
    try {
        const response = await apiPostClient.post("slots", data);
        console.log("Slot Creation Response:", response);
        toast.success(t("slotCreatedSuccess", { slotName: data?.slotName }), { position: "top-center" });
        return response.data;
    } catch (error) {
        if(error.response.status === 409) {
            toast.error(t("slotAlreadyExists", { slotName: data?.slotName }), { position: "top-center" });
            return null;
        } else if (error.response.status === 400) {
            toast.error(t("endDateError"), { position: "top-center" });
            return null;
        }
        return null;
    }
};

export const updateSlot = async (data, slotId) => {
    try {
        const response = await apiPutClient.put(`slots/${slotId}`, data);
    toast.success(t("slotUpdatedSuccess", { slotName: data?.slotName }), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach(field => {
                errorData?.errors[field].forEach(message => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const getSlot = async (data) => {
    try {
        const response = await apiGetClient.get(`slots/${data.id}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getPublishedSlotDetails = async (data) => {
    try {
        const response = await apiGetClient.get(`assessments/publishedslots/${data.id}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};